import { makeAutoObservable, runInAction } from 'mobx';
import { PAGINATION_CONFIGURATION } from 'src/constants';
import { HTTP_STATUS_RESPONSE_KEY } from 'src/constants/api';
import { PaginationResponseDTO } from 'src/dto/base.dto';
import {
	GetMortgageApplicationListDTO,
} from 'src/dto/mortgage-deal-application.dto';
import {
	IMDApplicationRequest,
	IMortgageDealItem,
	MortgageDeal
} from 'src/interfaces/mortgage-deal/mortgage-application-list';
import { IHttpService } from 'src/services/http.service';
import { plainToInstance } from 'class-transformer';
import { AddMortgageDealFavoriteBody, AddMortgageDealFavoriteDTO } from '../../dto/add-mortgage-deal-favorite.dto';
import { GetMortgageDealListDTO, GetMortgageDealListQuery } from '../../dto/mortgage-deal-list.dto';
import { GetSuggestedMortgageDealDTO, GetSuggestedMortgageDealQuery } from '../../dto/get-suggested-mortgage-deal.dto';

export interface IMortgageDealApplication {
	mortgageDealList?: IMortgageDealItem[];
	totalPages: number;
	totalRecords: number;
	pageSize: number;
	pageNumber: number;
	filter(filter: IMDApplicationRequest): Promise<void>;
	getMortgageDeal(filter: GetMortgageDealListQuery): Promise<MortgageDeal[] | undefined>;
	getSuggestedMortgageDeal(filter: GetSuggestedMortgageDealQuery): Promise<MortgageDeal[] | undefined>;
	addFavorite (data: AddMortgageDealFavoriteBody): Promise<boolean>
}

export class mortgageApplicationList implements IMortgageDealApplication {
	mortgageDealList?: IMortgageDealItem[];
	totalPages = 0;
	totalRecords = 0;
	pageSize = 0;
	pageNumber = 0;

	constructor(private readonly http: IHttpService) {
		makeAutoObservable(this);
	}

	public async addFavorite (data: AddMortgageDealFavoriteBody): Promise<boolean> {
		const rs = await this.http.request<
			AddMortgageDealFavoriteDTO,
			MortgageDeal[]
			>(new AddMortgageDealFavoriteDTO(data));

		return rs.responseKey === HTTP_STATUS_RESPONSE_KEY.SUCCESS;
	}

	public async filter(filter: IMDApplicationRequest): Promise<void> {
		const dto = new GetMortgageApplicationListDTO({
			...filter
		});

		const rs: PaginationResponseDTO<IMortgageDealItem[]> = await this.http.request<
			GetMortgageApplicationListDTO,
			IMortgageDealItem[]
		>(dto);

		if (rs.responseKey === HTTP_STATUS_RESPONSE_KEY.SUCCESS) {
			runInAction(() => {
				this.mortgageDealList = rs.data;
				this.totalRecords = rs.totalRecords || 0;
				this.totalPages = rs.totalPages || 0;
				this.pageSize = rs.pageSize || PAGINATION_CONFIGURATION.DEFAULT_PAGE_SIZE;
				this.pageNumber = rs.pageNumber || PAGINATION_CONFIGURATION.DEFAULT_PAGE;
			});
		}
	}

	public async getMortgageDeal(filter: GetMortgageDealListQuery): Promise<MortgageDeal[] | undefined> {
		const dto = new GetMortgageDealListDTO({
			...filter
		});

		const rs: PaginationResponseDTO<MortgageDeal[]> = await this.http.request<
			GetMortgageDealListDTO,
			MortgageDeal[]
			>(dto);

		if (rs.responseKey === HTTP_STATUS_RESPONSE_KEY.SUCCESS) {
				return rs.data?.map((item) => plainToInstance(MortgageDeal, item));
		}
	}

	public async getSuggestedMortgageDeal(filter: GetSuggestedMortgageDealQuery): Promise<MortgageDeal[] | undefined> {
		const dto = new GetSuggestedMortgageDealDTO({
			...filter
		});

		const rs: PaginationResponseDTO<MortgageDeal[]> = await this.http.request<
			GetSuggestedMortgageDealDTO,
			MortgageDeal[]
			>(dto);

		if (rs.responseKey === HTTP_STATUS_RESPONSE_KEY.SUCCESS) {
			return rs.data?.map((item) => plainToInstance(MortgageDeal, item));
		}
	}
}
